// 0 -> '0,00'
function numberToBRL(number, decimalPlaces = 2) {
  return Number(number).toLocaleString('pt-BR', {
    currency: 'BRL',
    minimumFractionDigits: decimalPlaces,
  });
}

// 0 -> 'R$ 0,00'
function beautifyNumberToBRL(number) {
  return `R$ ${numberToBRL(number)}`;
}

// '0,00' -> 0
function BRLtoNumber(number) {
  number = String(number);
  let matches = number.match(/(\,|\.)(\d{2})$/);
  if (matches && matches.length >= 3) {
    number = number.substr(0, number.length - 3).replace(/\D/g, '') + '.' + matches[2];
  }
  return parseFloat(number);
}

const moneyFormat = {
  prefix: 'R$ ',
  decimal: ',',
  thousands: '.',
  precision: 2
}

export {
  numberToBRL,
  beautifyNumberToBRL,
  BRLtoNumber,
  moneyFormat
}
